module.exports = __webpack_public_path__ + "static/media/traveler.94a5b076.png";